import React from 'react';
import {observer} from 'mobx-react'
import UIRenderer from "../containers/UIRenderer";
import { UIRendererProps } from '../datatypes';

const {MDBIcon} = require('mdbreact');

interface Props {
    domainDataId?:string;
    tla:string;
    flowName:string;
    onClick: ()=>void;
    rendererProps: UIRendererProps;
}
export default observer( class Modal extends React.Component<Props, {}> {

    constructor(props:Props){
      super(props)
    }

    render() {
        const {onClick, domainDataId, tla, flowName, rendererProps} = this.props;

        return (
            <div className="ui-renderer-modal" style={{display: 'block'}}>
                <div className="baseForm ui-renderer-modal-content">
                <MDBIcon id="modalClose" className="close" onClick={onClick} icon="times-circle"/>
                <UIRenderer
                    flowName={flowName}
                    domainDataId={domainDataId}
                    {...rendererProps}
                />
                </div>
            </div>
        )
    }
})